module.exports = __webpack_public_path__ + "static/media/vuetifyjs.0fa842cb.svg";